import moment from 'moment-timezone';
import { DateTimeInfo } from './../types/_general/date-time.interface';

const TIME_FORMAT = 'hh:mm a';
const DATE_FORMAT = 'MMM DD, YYYY';

function formatMomentDateAndTime(date: string | null, format = DATE_FORMAT): DateTimeInfo | null {
    if (date === null || date === undefined) {
        return null;
    }

    return {
        date: TimezoneHelper.formatMomentDate(date, false, format),
        time: TimezoneHelper.formatMomentTime(date),
    };
}

function formatMomentDate(date: string | null, includeHours = false, format = DATE_FORMAT): string {
    if (date === null || date === undefined) {
        return '';
    }

    const momentFormat = includeHours ? `${format} @ ${TIME_FORMAT}` : format;
    return moment(date).format(momentFormat);
}

function formatMomentTime(date: string | null): string {
    if (date === null || date === undefined) {
        return '';
    }

    return moment(date).format(TIME_FORMAT);
}

function startOfDateUTC(date: Date = new Date()): Date {
    return moment
        .utc({
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate(),
            hour: 0,
            minute: 0,
            second: 0,
        })
        .toDate();
}

function endOfDateUTC(date: Date = new Date()): Date {
    return moment
        .utc({
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate(),
            hour: 23,
            minute: 59,
            second: 59,
        })
        .toDate();
}

function firstDayOfCurrentUTCMonth(): Date {
    const now = new Date();
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), 1);
}

function firstDayOfMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function firstDayOfPreviousMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}

export const TimezoneHelper = {
    TIME_FORMAT,
    DATE_FORMAT,
    formatMomentDateAndTime,
    formatMomentDate,
    formatMomentTime,
    startOfDateUTC,
    endOfDateUTC,
    firstDayOfCurrentUTCMonth,
    firstDayOfMonth,
    firstDayOfPreviousMonth,
};
